import React, { ChangeEvent, useRef } from 'react';
import styled from 'styled-components';
import { lighten } from 'polished';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/SearchOutlined';
import Tooltip from '@material-ui/core/Tooltip';
//
import colors from 'theme/colors';

const { darkInputBorder, fontBody, globalIcon, white } = colors;

const Container = styled.div`
  align-items: center;
  background-color: ${white};
  border: none;
  border-radius: 3px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  height: 16px;
  padding: 16px;
  width: calc(100% - 32px);
  border: 1px solid ${darkInputBorder};
`;

const Input = styled.input`
  border: none;
  font-size: 14px;
  height: 100%;
  width: 90%;
  color: ${fontBody};

  &:active,
  &:focus {
    outline: none;
  }
`;

const colorGradient = 0.2;

const ClearIcon = styled.div`
  color: ${globalIcon};
  transition: color 0.15s ease;
  &:hover {
    cursor: pointer;
    color: ${lighten(colorGradient, globalIcon)};
  }
`;

const StyledSearchIcon = styled(SearchIcon)`
  color: ${globalIcon};
  transition: color 0.15s ease;
  &:hover {
    cursor: pointer;
    color: ${lighten(colorGradient, globalIcon)};
  }
`;

interface IMarkerSearchBoxProps {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  value: string;
  onClear: () => void;
  onBlur?: () => void;
  onClick?: () => void;
  placeholder?: string;
}

export default ({ onChange, value, onClear, onBlur, onClick, placeholder }: IMarkerSearchBoxProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  function handleClear() {
    onClear();
    if (inputRef?.current) {
      inputRef.current.focus();
    }
  }

  return (
    <Container>
      <Input
        data-testid="tid-search-input"
        ref={inputRef}
        onChange={onChange}
        value={value}
        onBlur={onBlur}
        onClick={onClick}
        placeholder={placeholder}
      />
      {value ? (
        <ClearIcon data-testid="tid-search-input-clear-button">
          <Tooltip title="Clear search input">
            <CloseIcon onClick={handleClear} />
          </Tooltip>
        </ClearIcon>
      ) : (
        <StyledSearchIcon />
      )}
    </Container>
  );
};
